import Header from './Header';
import Footer from './Footer';
import React,{useEffect} from 'react';
import AOS from "aos";

const Layout = ({ children,gradient}) => {
  useEffect(()=>{
    AOS.init({
      once:true,
      duration: 500,
    });
  },[])
  return (
    <>
      <Header gradient={gradient}/>
      {children}
      <Footer />
    </>
  );
};
export default Layout;
